import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import SectionHeader from '../components/SectionHeader';
// import ReservationSection from '../components/ReservationSection';

const ReservationPage: React.FC = () => {
  return (
    <div className="pt-20 bg-primary-black min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <SectionHeader
          eyebrow="RESERVATIONS"
          title="Make a Reservation"
          subtitle="Book your table at the restaurant or reserve your snooker / pool table today"
          darkMode={true}
        />

        <div className="max-w-4xl mx-auto mt-12">
          {/* Main Contact Card */}
          <div className="bg-primary-black border border-primary-gold/20 rounded-lg p-8 mb-8 shadow-2xl">
            <h2 className="text-3xl font-bold text-primary-gold mb-6 font-display text-center">
              Call Us to Book
            </h2>
            <p className="text-gray-300 text-center mb-8 text-lg">
              To make a reservation for our restaurant or to book a snooker or pool table, 
              please give us a call during our opening hours.
            </p>

            {/* Contact Details */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="flex items-start space-x-4">
                <Phone className="w-6 h-6 text-primary-gold mt-1 flex-shrink-0" />
                <div>
                  <h3 className="text-white font-semibold mb-1">Telephone</h3>
                  <a href="tel:01324636330" className="text-primary-gold hover:text-primary-gold-light text-xl">
                    01324 636330
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Mail className="w-6 h-6 text-primary-gold mt-1 flex-shrink-0" />
                <div>
                  <h3 className="text-white font-semibold mb-1">Email</h3>
                  <a href="mailto:enquiries@thecreamerysportsbar.co.uk" className="text-primary-gold hover:text-primary-gold-light break-all">
                    enquiries@thecreamerysportsbar.co.uk
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <MapPin className="w-6 h-6 text-primary-gold mt-1 flex-shrink-0" />
                <div>
                  <h3 className="text-white font-semibold mb-1">Address</h3>
                  <p className="text-gray-300">
                    Bainsford Main Street<br />
                    Falkirk<br />
                    FK2 7NU
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Clock className="w-6 h-6 text-primary-gold mt-1 flex-shrink-0" />
                <div>
                  <h3 className="text-white font-semibold mb-1">Opening Hours</h3>
                  <p className="text-gray-300">
                    <strong>Restaurant:</strong><br />
                    Sun-Fri: 12pm - 7pm<br />
                    Sat: 12pm - 7:30pm
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Restaurant & Snooker Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Restaurant Card */}
            <div className="bg-primary-black border border-primary-gold/20 rounded-lg p-6 shadow-2xl">
              <h3 className="text-2xl font-bold text-primary-gold mb-4 font-display">Restaurant Reservations</h3>
              <p className="text-gray-300 mb-4">
                Book your table for lunch or dinner. We recommend booking in advance, especially for weekends.
              </p>
              <div className="text-gray-300">
                <p className="font-semibold text-white mb-2">Opening Hours:</p>
                <p>Sun-Fri: 12pm - 7pm</p>
                <p>Sat: 12pm - 7:30pm</p>
              </div>
            </div>

            {/* Snooker & Pool Card */}
            <div className="bg-primary-black border border-primary-gold/20 rounded-lg p-6 shadow-2xl">
              <h3 className="text-2xl font-bold text-primary-gold mb-4 font-display">Snooker & Pool Tables</h3>
              <p className="text-gray-300 mb-4">
                Reserve a snooker or pool table for your game. Walk-ins welcome subject to availability.
              </p>
              <div className="text-gray-300">
                <p className="font-semibold text-white mb-2">Opening Hours:</p>
                <p>Mon-Sun: 11am - 11pm</p>
                <p className="mt-3 font-semibold text-white">Table Rates:</p>
                <p>Pool: £11/hour</p>
                <p>Snooker: £11/hour</p>
              </div>
            </div>
          </div>
        </div>

        {/* Form kept in codebase but commented out */}
        {/* <ReservationSection /> */}
      </div>
    </div>
  );
};

export default ReservationPage;
